import { action, computed, observable } from 'mobx'
import { Group } from '@/model/types/goods'

class MallGoodsStore {
    @observable
    mallGoodGroup: Group[] = []

    @computed
    get defaultGroupId() {
        return this.mallGoodGroup.find(g => g.is_default)?.id
    }

    @action
    setMallGoodsGroup(val: Group[]) {
        this.mallGoodGroup = val
    }
}

export const mallGoodsStore = new MallGoodsStore()
